<template>
	<div class="logon">
		<div class="tc f24px mat30">正在跳转...</div>
	</div>
</template>

<script>
	
	
	export default {
		name: 'wait',
		components: {
		 
		},
		props: {
			
		},
		data () {
			return {
				code: "",
				path: "",
			}
		},
		created() {
			
		},
		mounted() {
			if (this.$route.query.code) {
				this.code = this.$route.query.code;
				this.state = this.$route.query.state;
				if (this.state == 1) {
					this.wxBack();
				} else {
					this.wxEdit();
				}
			}
		},
		methods: {
			//微信登录
			wxBack () {
				this.$get("/api/login/wx_back",{
					code: this.code
				})
				.then(res => {
					localStorage.setItem("token", res.data.token);
					setTimeout(() => {
						this.$router.push({path: '/', replace: true});
					}, 1000);
				});
			},
			//微信绑定
			wxEdit () {
				this.$get("/api/user/post_wx_edit",{
					code: this.code,
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.$message({
						duration: 1500,
						message: res.msg,
						type: 'success'
					});
					setTimeout(() => {
						this.$router.push({path: '/personal_protect', replace: true});
					}, 1500);
				});
			},
		},
	}
</script>

<style>
</style>
